import {environment} from '../config/index'
import {ACTIVE_CHAPTER_ID} from '@/app/store/modules/app'
import store from '@/app/store'
import Home from '@/app/views/Home'
import Chapter from '@/app/views/Chapter'
import ChapterVideo from '@/app/views/ChapterVideo'
import ChapterArt from '@/app/views/ChapterArt'
import Auction from "@/app/views/Auction"
import NotFound from '@/app/views/NotFound'

export const HOME = 'home'
export const CHAPTER = 'chapter'
export const CHAPTER_VIDEO = 'chapter-video'
export const CHAPTER_ART = 'chapter-art'
export const AUCTION = 'auction'
export const NOT_FOUND = '404'

const commitActiveChapterId = (to, from, next) => {
    const {id} = to.params
    // [TODO]: validate if chapter exists and if it has video.
    store.commit(ACTIVE_CHAPTER_ID, id)
    next()
}

const routes = {
    mode: 'hash',
    base: environment.url.subdirectory,
    routes: [
        {
            path: '/',
            name: HOME,
            component: Home,
        },
        {
            path: '/capitulo',
            name: CHAPTER,
            component: Chapter,
        },
        {
            path: '/entrevista/:id',
            name: CHAPTER_VIDEO,
            component: ChapterVideo,
            beforeEnter: commitActiveChapterId,
        },
        {
            path: '/libreta/:id',
            name: CHAPTER_ART,
            component: ChapterArt,
            beforeEnter: commitActiveChapterId,
        },
        {
            path: '/subasta',
            name: AUCTION,
            component: Auction
        },
        {
            path: '*',
            name: NOT_FOUND,
            component: NotFound,
        },
    ],
}

export default routes



// WEBPACK FOOTER //
// ./src/app/routes.js